document.addEventListener("turbo:load", (event) => {
  $(function () {
    $(".ui.checkbox").checkbox();
    $(".ui.dropdown").dropdown();
  });
});
